// Frontend mirror of the backend source-terminology -> Dactyl-Concept-type guardrail
// (api/app/utils/paperCharacterization/sourceAxisRules.ts, DCTL-2130). The concept
// editor uses it to restrict/lock the type choice for a picked EVS hit; the backend
// re-validates on POST /concepts/add. Keep the two in sync.
//
// Firm rule: medrt (MED-RT MoA classes) -> moa ONLY; ncit/ncim -> the NCI-anchored
// types (normalization/disease/anatomy/drug_class), never moa.

// The EVS terminologies the add flow supports, and the curated fan set an "All" search
// expands to.
export const SUPPORTED_EVS_TERMINOLOGIES = ["ncit", "ncim", "medrt"];

// Terminology selector options for the EVS search tab (label + value), plus "All".
export const EVS_TERMINOLOGY_OPTIONS = [
	{ value: "all", title: "All" },
	{ value: "ncit", title: "NCI Thesaurus (NCIt)" },
	{ value: "ncim", title: "NCI Metathesaurus (NCIm)" },
	{ value: "medrt", title: "MED-RT (MoA)" },
];

const ALLOWED_TYPES_BY_TERMINOLOGY = {
	ncit: ["normalization", "disease", "anatomy", "drug_class"],
	ncim: ["normalization", "disease", "anatomy", "drug_class"],
	medrt: ["moa"],
};

// The Dactyl Concept types a hit from `terminology` may be anchored as. Unknown/blank
// terminology falls back to the NCI-anchored set (the legacy add path).
export function allowedTypesForTerminology(terminology) {
	const key = (terminology || "").trim().toLowerCase();
	return ALLOWED_TYPES_BY_TERMINOLOGY[key] || ALLOWED_TYPES_BY_TERMINOLOGY.ncim;
}

// The Dactyl code system a terminology's codes belong to (for id-chip labeling).
export function codeSystemForTerminology(terminology) {
	return (terminology || "").trim().toLowerCase() === "medrt"
		? "MED_RT"
		: "NCI_EVS";
}
